module.exports = __webpack_public_path__ + "img/8.196fc8fc.jpg";